import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractDynamicComponent } from '@components/abstracts';
import { PushLiens } from '@components/push-liens/models';
import { OptionCardComponent } from '@shared/components/option-card';
import { SvgComponent } from '@shared/components/svg';
import { TitleComponent } from '@shared/components/title';
import { LinkDirective } from '@shared/directives';

@Component({
  selector: 'app-push-liens',
  templateUrl: './push-liens.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TitleComponent, OptionCardComponent, LinkDirective, SvgComponent],
})
export class PushLiensComponent extends AbstractDynamicComponent<PushLiens> {
  protected onLinkClick(label: string, index: number) {
    let gtm: typeof this.data.gtmConfigCta1 | null = null;

    if (index === 0) {
      gtm = this.data.gtmConfigCta1;
    } else if (index === 1) {
      gtm = this.data.gtmConfigCta2;
    }

    if (!gtm) return;

    this.emitGtmEvent({
      event: gtm.event,
      group: gtm.group,
      description: gtm.description,
      context: gtm.context,
      button_text_value: label,
      event_type: 'click',
    });
  }
}
